import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
// import EditorJS, { OutputData } from '@editorjs/editorjs';

@Component({
  selector: 'app-text-editor',
  standalone: true,
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.css'],
})
export class TextEditorComponent {
  @Input() readOnly: boolean = false;
  // @Input() initialData?: OutputData;
  @Output() saveData: EventEmitter<any> = new EventEmitter();

  @ViewChild('editorjs', { read: ElementRef, static: true })
  textEditor!: ElementRef;

  // private editor!: EditorJS;

  // ngAfterViewInit(): void {
  //   this.initEditor();
  // }

  // initEditor(): void {
  //   this.editor = new EditorJS({
  //     autofocus: true,
  //     holder: this.textEditor.nativeElement,
  //     readOnly: this.readOnly,
  //     placeholder: "Press '/' to view available tools",
  //     data: this.initialData,
  //     minHeight: 350,
  //     tools: {
  //       header: {
  //         class: Header,
  //         // inlineToolbar: ['link'],
  //         shortcut: 'CMD+SHIFT+H',
  //       },
  //       image: SimpleImage,
  //       table: {
  //         class: Table,
  //         shortcut: 'CMD+SHIFT+T',
  //         config: {
  //           rows: 2,
  //           cols: 3,
  //         },
  //       },
  //       // linkTool: {
  //       //   class: LinkTool,
  //       //   config: {
  //       //     endpoint: 'http://localhost:8008/fetchUrl', // Your backend endpoint for url data fetching,
  //       //   },
  //       // },
  //       checklist: {
  //         class: Checklist,
  //         inlineToolbar: true,
  //       },
  //       list: {
  //         class: List,
  //         inlineToolbar: true,
  //         config: {
  //           defaultStyle: 'unordered',
  //         },
  //       },
  //       marker: {
  //         class: Marker,
  //         shortcut: 'CMD+SHIFT+M',
  //       },
  //       quote: {
  //         class: Quote,
  //         inlineToolbar: true,
  //         shortcut: 'CMD+SHIFT+O',
  //         config: {
  //           quotePlaceholder: 'Enter a quote',
  //           captionPlaceholder: "Quote's author",
  //         },
  //       },
  //     },
  //   });
  // }

  // async data(): Promise<OutputData> {
  //   return await this.editor?.save();
  // }

  // async loadData(data: OutputData) {
  //   await this.editor?.isReady.then(async () => {
  //     await this.editor?.render(data);
  //   });
  // }

  print() {
    const printContent = document.getElementById('printContent');
    const WindowPrt = window.open(
      '',
      '',
      'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0'
    );
    if (WindowPrt != null && printContent != null) {
      WindowPrt.document.write(printContent.innerHTML);
      WindowPrt.document.close();
      WindowPrt.focus();
      WindowPrt.print();
      WindowPrt.close();
    }
  }
}
